import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { POST, GET } from '../../services/api';

// Async thunk for creating a notification
export const createNotification = createAsyncThunk(
  'notification/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST('/tenant/notification', data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || "Something went wrong");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Failed to create notification");
    }
  }
);

export const listNotificationFun = createAsyncThunk(
  'data/list/notification',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GET('/tenant/notification', {...params});
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch data');
    }
  }
);



// http://localhost:5600/api/v1/tenant/notification?page=1&size=10&sort_order=ASC&sort=created_at

const NotificationSlice = createSlice({
  name: 'notification',
  initialState: {
    newNotification: null,
    notificationLoading: false,
    notificationError: null,

    listNotification: null,
    listNotificationCount: "",
    listNotificationLoading: false,
    listNotificationError: null,

  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createNotification.pending, (state) => {
        state.notificationLoading = true;
        state.notificationError = null;
      })
      .addCase(createNotification.fulfilled, (state, action) => {
        state.notificationLoading = false;
        state.newNotification = action.payload;
      })
      .addCase(createNotification.rejected, (state, action) => {
        state.notificationLoading = false;
        state.notificationError = action.payload || action.error.message;
      })

      .addCase(listNotificationFun.pending, (state) => {
        state.listNotificationLoading = true;
        state.listNotificationError = null;
      })
      .addCase(listNotificationFun.fulfilled, (state, action) => {
        state.listNotificationLoading = false;
        state.listNotification = action.payload.result?.rows;
        state.listNotificationCount = action.payload?.result?.count;
      })
      .addCase(listNotificationFun.rejected, (state, action) => {
        state.listNotificationLoading = false;
        state.listNotificationError = action.payload || action.error.message;
      });
  },
});

export default NotificationSlice.reducer;
